import styled from "styled-components";
import {
  space,
  flexbox,
  layout,
  SpaceProps,
  FlexboxProps,
  LayoutProps,
  BorderProps,
  border,
} from "styled-system";

type BoxProps = SpaceProps & FlexboxProps & LayoutProps & BorderProps;

const Box = styled.div<BoxProps>`
  ${space};
  ${flexbox};
  ${layout};
  ${border};
`;

export default Box;
